import React from 'react';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { resolveColor } from '../../utils/colorUtils';

interface HomeHeaderProps {
  config: any;
  title: string;
}

export const HomeHeader: React.FC<HomeHeaderProps> = ({ config, title }) => {
  // Résoudre la couleur de fond du header
  const headerBackgroundColor = resolveColor(config['HFBack-color'], config, config['dark-color']);

  // Résoudre la couleur du texte
  const headerTextColor = resolveColor(config['HFTxt-color'], config, config['light-color']);

  // Récupérer le logo depuis la configuration Airtable
  // Le logo est un champ de type "pièce jointe" dans la table "hotels"
  const logo = config.logo?.[0]?.url;

  return (
    <>
      {/* Extension de la couleur vers le haut */}
      <div 
        className="fixed top-0 left-0 right-0 h-[1000px] -translate-y-full -z-10"
        style={{ backgroundColor: headerBackgroundColor }}
      />
      
      {/* Header principal */}
      <header 
        className="shadow-md header"
        style={{ backgroundColor: headerBackgroundColor }}
      >
        <div className="header-content relative">
          {/* Left spacer with fixed width */}
          <div className="w-10" />
          
          {/* Logo ou titre centré */}
          {logo ? (
            <div 
              className="absolute left-1/2 -translate-x-1/2 h-full flex items-center justify-center px-[10px] py-[5px]"
              style={{ maxWidth: 'calc(100% - 5rem)' }}
            >
              <img 
                src={logo}
                alt={title}
                className="h-[calc(100%-10px)] w-auto object-contain"
              />
            </div>
          ) : (
            <h1 
              className="absolute left-1/2 -translate-x-1/2 text-2xl font-light text-center truncate px-[10px] max-w-[calc(100%-5rem)]"
              style={{ color: headerTextColor }}
            >
              {title}
            </h1>
          )}
          
          {/* Language switcher with text */}
          <div className="w-10 flex justify-end">
            <LanguageSwitcher showText={true} textColor={headerTextColor} />
          </div>
        </div>
      </header>
    </>
  );
};